import { createEntityAdapter } from "@reduxjs/toolkit";

export const userSavedSearchEntityAdapter =
  createEntityAdapter<API.UserSavedSearch>();
